<script lang="ts" setup>
	import type { ListContext } from '~/components/Shared/list-item.vue'

	defineProps<{
		details: ListContext
		fileType?: 'img' | 'pdf'
		loading?: boolean
		useFooter?: boolean
		downloading?: boolean
		exclude?: string[]
		pendingId?: boolean
		loadingText?: string
	}>()
	const emits = defineEmits<{
		(event: 'download'): void
		(event: 'view'): void
	}>()
</script>

<template>
	<div
		v-if="!loading"
		class="relative mx-auto flex min-h-[280px] max-w-[450px] flex-col justify-between rounded border"
	>
		<div class="p-5">
			<slot name="prepend-list-item"></slot>
			<ul
				class="flex grid-cols-2 flex-wrap justify-between gap-7 gap-y-6 sm:grid sm:grid-cols-[220px_minmax(85px,_1fr)] sm:gap-x-4"
			>
				<template v-for="(item, k) in details" :key="k">
					<li v-if="!exclude?.includes(k)" class="sm:w-auto">
						<span class="text-xs font-normal text-gray-500">{{ k }}</span>
						<div class="mt-1 text-sm font-medium capitalize text-gray-600">
							<slot name="value" :record="item" :data-index="String(k)?.toLowerCase().replace(/ /g, '_')">
								<slot :name="String(k)?.toLowerCase().replace(/ /g, '_')" :record="item">
									<h4>{{ item || '---' }}</h4>
								</slot>
							</slot>
						</div>
					</li>
				</template>
			</ul>

			<slot name="append-list-item"></slot>
		</div>

		<footer
			v-show="useFooter"
			class="h-[50px] items-center justify-between border-t p-5"
			:class="[pendingId ? 'bg-warning-50' : 'border-gray-100 bg-gray-50', { flex: useFooter }]"
		>
			<div v-if="pendingId" class="flex w-full items-center justify-center gap-x-2">
				<span class="font-medium text-warning-500"> {{ loadingText || 'Generating H.M.O ID' }} </span>
				<lazy-tools-icon icon="eclipse" dir="line" />
			</div>
			<slot v-else name="footer">
				<div class="flex items-center gap-x-3">
					<lazy-tools-icon
						:dir="fileType !== 'pdf' ? 'media' : 'documents'"
						:icon="fileType !== 'pdf' ? 'gallery' : 'pdf'"
					/>
					<span class="text-xs font-medium text-gray-800">H.M.O ID</span>
				</div>

				<div class="flex items-center gap-x-3.5">
					<slot name="button-group">
						<a-button
							:loading="downloading"
							:disabled="downloading"
							size="middle"
							class="!h-auto rounded-xl !bg-primary-2 !p-[8px_20px] text-sm font-medium tracking-wide !text-white hover:!bg-primary-400"
							aria-label="download hmo id"
							@click="emits('download')"
						>
							Download
						</a-button>
						<button type="button" class="font-medium tracking-wide text-primary-2" @click="emits('view')">
							View
						</button>
					</slot>
				</div>
			</slot>
		</footer>
	</div>
	<loader-skeleton v-else :height="280" :count="1" class-list="!my-5" :max-width="false" />
</template>
